/* tslint:disable */
import {
  Vendor,
  Profile
} from '../index';

declare var Object: any;
export interface UserGroupInterface {
  "vendorId"?: any;
  "name": string;
  "accessRights": Array<any>;
  "status": number;
  "createdAt": Date;
  "updatedAt": Date;
  "updatedBy"?: any;
  "id"?: any;
  vendor?: Vendor;
  profile?: Profile[];
}

export class UserGroup implements UserGroupInterface {
  "vendorId": any;
  "name": string;
  "accessRights": Array<any>;
  "status": number;
  "createdAt": Date;
  "updatedAt": Date;
  "updatedBy": any;
  "id": any;
  vendor: Vendor;
  profile: Profile[];
  constructor(data?: UserGroupInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UserGroup`.
   */
  public static getModelName() {
    return "UserGroup";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UserGroup for dynamic purposes.
  **/
  public static factory(data: UserGroupInterface): UserGroup{
    return new UserGroup(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UserGroup',
      plural: 'userGroups',
      path: 'userGroups',
      idName: 'id',
      properties: {
        "vendorId": {
          name: 'vendorId',
          type: 'any'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "accessRights": {
          name: 'accessRights',
          type: 'Array&lt;any&gt;'
        },
        "status": {
          name: 'status',
          type: 'number',
          default: 0
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
        vendor: {
          name: 'vendor',
          type: 'Vendor',
          model: 'Vendor',
          relationType: 'belongsTo',
                  keyFrom: 'vendorId',
          keyTo: 'id'
        },
        profile: {
          name: 'profile',
          type: 'Profile[]',
          model: 'Profile',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userGroupId'
        },
      }
    }
  }
}
